module.exports = __webpack_public_path__ + "img/dj-logo.354248e7.png";